var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9998 52.3337C63.2215 52.3337 65.8332 49.722 65.8332 46.5003C65.8332 43.2787 63.2215 40.667 59.9998 40.667C56.7782 40.667 54.1665 43.2787 54.1665 46.5003C54.1665 49.722 56.7782 52.3337 59.9998 52.3337Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6668 59.333H37.3335C36.0002 59.333 34.8335 58.1663 34.8335 56.833C34.8335 55.4997 36.0002 54.333 37.3335 54.333H82.6668C84.0002 54.333 85.1668 55.4997 85.1668 56.833C85.1668 58.1663 84.0002 59.333 82.6668 59.333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 56.833H62.5V81.4997H57.5V56.833Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55 102C53.6667 102 52.5 100.833 52.5 99.4997V56.833C52.5 55.4997 53.6667 54.333 55 54.333C56.3333 54.333 57.5 55.4997 57.5 56.833V99.4997C57.5 100.833 56.3333 102 55 102Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65 102C63.6667 102 62.5 100.833 62.5 99.4997V56.833C62.5 55.4997 63.6667 54.333 65 54.333C66.3333 54.333 67.5 55.4997 67.5 56.833V99.4997C67.5 100.833 66.3333 102 65 102Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9998 117C34.1665 117 13.1665 95.9997 13.1665 70.1663C13.1665 44.333 34.1665 23.333 59.9998 23.333C85.8332 23.333 106.833 44.333 106.833 70.1663C106.833 95.9997 85.8332 117 59.9998 117ZM59.9998 28.1663C36.8332 28.1663 18.1665 46.9997 18.1665 69.9997C18.1665 93.1663 36.9998 111.833 59.9998 111.833C82.9998 111.833 101.833 92.9997 101.833 69.9997C101.833 46.9997 83.1665 28.1663 59.9998 28.1663Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.566 23.4967C114.566 35.1868 105.09 44.6634 93.3996 44.6634C81.7096 44.6634 72.2329 35.1868 72.2329 23.4967C72.2329 11.8067 81.7096 2.33008 93.3996 2.33008C105.09 2.33008 114.566 11.8067 114.566 23.4967ZM90.0394 33.222C89.3727 33.222 88.706 32.8887 88.206 32.5554L82.206 26.5554C81.206 25.5554 81.206 24.0554 82.206 23.0554C83.206 22.0554 84.706 22.0554 85.706 23.0554L89.8727 27.222L102.206 14.8887C103.206 13.8887 104.706 13.8887 105.706 14.8887C106.706 15.8887 106.706 17.3887 105.706 18.3887L91.706 32.3887C91.3727 33.0554 90.706 33.222 90.0394 33.222Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessible);
export default __webpack_public_path__ + "static/media/Accessible.1fcd4d14b51ec0349fc9ec88a4a6da82.svg";
export { ForwardRef as ReactComponent };